import { render, staticRenderFns } from "./tcmDetail.vue?vue&type=template&id=2a89b988&scoped=true"
import script from "./tcmDetail.vue?vue&type=script&lang=js"
export * from "./tcmDetail.vue?vue&type=script&lang=js"
import style0 from "./tcmDetail.vue?vue&type=style&index=0&id=2a89b988&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a89b988",
  null
  
)

export default component.exports